import { InjectionToken } from '@angular/core';

export const SESSION_STORAGE: InjectionToken<Storage> = new InjectionToken<Storage>('Session storage', {
  providedIn: 'root',
  factory: () => window.sessionStorage,
});
